import React, { useState, useEffect } from "react";
import { getStockReg } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";

const FuelSaleStockReg = () => {
  const { user, access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({
    startingDate: "",
    endingDate: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const [itemsQueue, setItemsQueue] = useState([]);
  const formatDate = (dateStr) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(dateStr).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  };

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = async (e) => {
    if (!state.startingDate && !state.endingDate)
      return message.error("Please type date !");
    let data = {
      mSdt: state.startingDate,
      mEdt: state.endingDate,
      siteId: Number(user.siteId),
    };
    try {
      setLoading(true); // disable button
      const results = await getStockReg(data, access_token);
      if (results.success) {
        const payload = results.data.reduce((acc, curr) => {
          return [
            ...acc,
            {
              enteredOn: curr.enteredOn,
              tankNumber: curr.tankNumber,
              dipMm: Number(curr.dipMm),
              openingBalence: Number(curr.openingBalence),
              purchaseQuantity: Number(curr.purchaseQuantity),
              SaleQuantity: Number(curr.SaleQuantity),
              gain: Number(curr.gain),
              closingDip: Number(curr.closingDip),
              closingDipQty: Number(curr.closingDipQty),
              purchaseRate: Number(curr.purchaseRate),
              itemCode: Number(curr.itemCode),
              meterCheck: Number(curr.meterCheck),
            },
          ];
        }, []);
        setItemsQueue(payload);
        generatePDF(payload);
      } else {
        message.error(results.message);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    } finally {
      setLoading(false); // re-enable button
    }
  };
  console.log(state, "state");
  const clearState = () => {
    setItemsQueue([]);
  };

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    // Sort data by ICODE then TDate
    const sortedData = [...data].sort((a, b) => {
      if (a.itemCode === b.itemCode) {
        return new Date(a.TDate) - new Date(b.TDate);
      }
      return a.itemCode - b.itemCode;
    });

    // Group by itemCode
    const groupedData = sortedData.reduce((acc, row) => {
      if (!acc[row.itemCode]) acc[row.itemCode] = [];
      acc[row.itemCode].push(row);
      return acc;
    }, {});

    const doc = new jsPDF("l", "mm", "a4");
    const icodeList = Object.keys(groupedData).sort((a, b) => a - b);

    const formatDay = (dateStr) => new Date(dateStr).getDate();
    const productMap = {
      1: "Super",
      2: "Diesel",
      3: "HOBC",
    };
    icodeList.forEach((itemCode, idx) => {
      const rows = groupedData[itemCode];
      const TNO = rows[0]?.tankNumber || "";

      if (idx > 0) doc.addPage();

      const now = new Date();
      const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
      doc.setFontSize(8);
      doc.text(`Printed on: ${printDateTime}`, 262, 20, { align: "right" });
      // Title for each itemCode
      doc.setFontSize(10);
      doc.text("Fuel Sale & Stock Register", 148, 5, { align: "center" });
      doc.setFontSize(16);
      doc.text(`${siteName}`, 148, 11, { align: "center" });
      doc.setFontSize(12);
      doc.text(`${siteAddress}`, 148, 16, { align: "center" });
      doc.setFontSize(10);
      doc.text(`Product: ${productMap[itemCode] || itemCode}`, 15, 15);
      doc.setFontSize(10);
      doc.text(`Tank: ${TNO}`, 15, 20);
      doc.text(
        `From: ${formatDate(state.startingDate)} To: ${formatDate(
          state.endingDate
        )}`,
        148,
        20,
        { align: "center" }
      );

      // Prepare rows
      const tableRows = rows.map((r) => {
        const total = r.openingBalence + r.purchaseQuantity;
        const closingStock = total - r.SaleQuantity;
        const netBookStock = closingStock + r.meterCheck;
        const netSales = r.SaleQuantity - r.meterCheck;

        return [
          formatDay(r.enteredOn), // also use enteredOn, not TDate
          (r.openingBalence ?? 0).toLocaleString(),
          (r.purchaseQuantity ?? 0).toLocaleString(),
          total.toLocaleString(),
          (r.SaleQuantity ?? 0).toLocaleString(),
          closingStock.toLocaleString(),
          (r.meterCheck ?? 0).toLocaleString(),
          netBookStock.toLocaleString(),
          netSales.toLocaleString(),
          (r.gain ?? 0).toLocaleString(),
          (r.closingDipQty ?? 0).toLocaleString(), // fixed key
          (r.closingDip ?? 0).toLocaleString(),
        ];
      });

      // Footer totals
      // Footer totals (fixed to match payload field names)
      const totalPurchase = rows.reduce(
        (sum, r) => sum + r.purchaseQuantity,
        0
      );
      const totalSale = rows.reduce((sum, r) => sum + r.SaleQuantity, 0);
      const totalMCK = rows.reduce((sum, r) => sum + r.meterCheck, 0);
      const totalNetSales = rows.reduce(
        (sum, r) => sum + (r.SaleQuantity - r.meterCheck),
        0
      );
      const totalGain = rows.reduce((sum, r) => sum + r.gain, 0);

      tableRows.push([
        { content: "Total:", colSpan: 2, styles: { fontStyle: "bold" } },
        totalPurchase.toLocaleString(),
        "",
        totalSale.toLocaleString(),
        "",
        totalMCK.toLocaleString(),
        "",
        totalNetSales.toLocaleString(),
        totalGain.toLocaleString(),
        "",
        "",
      ]);

      // Render table
      autoTable(doc, {
        head: [
          [
            "Date",
            "Opening",
            "Purchase",
            "Total",
            "Sale",
            "Closing Stock",
            "Testing",
            "Book Stock",
            "Net Sales",
            "Gain",
            "Closing Qty",
            "Closing Dip",
          ],
        ],
        body: tableRows,
        startY: 25,
        theme: "grid",
        margin: { left: 15, right: 5 },
        styles: {
          fontSize: 9,
          cellPadding: 0.5,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          valign: "middle",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { halign: "center", cellWidth: 18 },
          2: { halign: "center", cellWidth: 22 },
          3: { halign: "center", cellWidth: 22 },
          4: { halign: "center", cellWidth: 22 },
          5: { halign: "center", cellWidth: 22 },
          6: { halign: "center", cellWidth: 15 },
          7: { halign: "center", cellWidth: 23 },
          8: { halign: "center", cellWidth: 25 },
          9: { halign: "center", cellWidth: 25 },
          10: { halign: "center", cellWidth: 25 },
          11: { halign: "center", cellWidth: 22 },
        },
      });
    });

    // Open PDF
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-32">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">Fuel Sale & Stock Register</h1>
              </div>
              <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                <div>
                  <label className="text-white" for="fname">
                    Starting Date:
                  </label>
                  <input
                    name="startingDate"
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    onChange={onChangeText}
                  />
                </div>
                <div>
                  <label className="text-white" for="fname">
                    Ending Date:
                  </label>
                  <input
                    name="endingDate"
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    onChange={onChangeText}
                  />
                </div>
                <div>
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                    clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FuelSaleStockReg;
